import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";

export default function BackButton() {
    const history = useHistory();

    function handlePress() {
        history.goBack();
    }

    return (
        <>
            <IconButton onClick={handlePress} component="span" size="large">
                <ArrowBackIcon />
            </IconButton>
        </>
    );
}
